<div class="tags-container">
    <lib-table 
        [dataSummary]="tableSummary"
        [tableColumns]="tableColumns"
        [pagination]="undefined"
        [displayFilterButtons]="false"
        [displayRefreshButtons]="false"
        [displaySearchInput]="true"
        [searchPlaceholder]="'search.search' | translate"
        [withCustomFilter]="false"
        (paginationChange)="onPageChange($event)"
        (globalSearchChange)="onGlobalSearch($event)"
        (sortChange)="onSortChange($event)"
        (refreshData)="onRefresh()"
        (rowExpand)="onRowExpand($event)"
    >
        <div class="tags-info-container"> 
            <span class="title-3">{{'export-creation.table.title' | translate}}</span>
            <i class="fa-solid fa-circle-question" pTooltip="{{'export-creation.table.tooltip' | translate}}"></i>
        </div>
    </lib-table>
</div>
